import React from "react";
import { Button } from "../../button/Button";
import { Colors } from "../../../utils/colors";
import {
  useCourtBookingStore,
  useSelectCircleStore,
} from "../../../stores/StoreContext";
import { TCText } from "../../TCText/TCText";
import { PlayerItem } from "../../playerItem/PlayerItem";
import { observer } from "mobx-react-lite";
import { TOTAL_PLAYERS_IN_MATCH } from "../../../utils/data";

type props = {};

export const RemovePlayersModal: React.FC<props> = observer(() => {
  const selectCircleStore = useSelectCircleStore();
  const courtBookingStore = useCourtBookingStore();

  return selectCircleStore.isShowRemoveExtraPlayersDialog ? (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 1002,
      }}>
      <div
        style={{
          backgroundColor: "white",
          borderRadius: 16,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          width: "90%",
          boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
          flexDirection: "column",
          minHeight: "fit-content",
          maxHeight: "90vh",
          overflow: "auto",
          position: "relative",
          paddingTop: 20,
          paddingBottom: 20,
        }}>
        <TCText
          style={{ fontWeight: 500, fontSize: 14 }}
          value="Please uncheck the players to remove"
        />
        <div
          style={{
            width: "100%",
            paddingTop: 10,
            paddingLeft: 10,
            paddingRight: 10,
          }}>
          {selectCircleStore.selectedPlayers.map((player) => {
            return (
              <PlayerItem
                key={player.userId}
                name={player.name}
                lastMatch={player.lastMatchDate}
                imageUrl={player.userImageUrl}
                rating={player.userRating.toString()}
                isSelected={selectCircleStore.selectedPlayersToRemove.every(
                  (p) => p.userId !== player.userId
                )}
                onSelect={() => {
                  selectCircleStore.addPlayerToRemoveFromSelected(player);
                }}
                isExclude={false}
              />
            );
          })}
        </div>
        <div
          style={{
            display: "flex",
            gap: 5,
            width: "100%",
            paddingTop: 20,
            paddingLeft: 15,
            paddingRight: 15,
          }}>
          <Button
            text="Cancel"
            onPress={() => {
              selectCircleStore.isShowRemoveExtraPlayersDialog = false;
              courtBookingStore.setTotalPlayersInMatch(TOTAL_PLAYERS_IN_MATCH);
              selectCircleStore.selectedPlayersToRemove = [];
            }}
            btnStyle={{
              width: "100%",
              backgroundColor: "transparent",
              marginTop: 20,
              height: 50,
              border: `2px solid ${Colors.darkBrown}`,
            }}
            textStyle={{ color: Colors.darkBrown }}
          />
          <Button
            text="Done"
            onPress={() => {
              selectCircleStore.isShowRemoveExtraPlayersDialog = false;
              selectCircleStore.removePlayersFromSelectedPlayersList();
            }}
            btnStyle={{
              width: "100%",
              backgroundColor: Colors.darkBrown,
              marginTop: 20,
              height: 50,
            }}
            textStyle={{ color: "white", fontSize: 13 }}
            disabled={
              selectCircleStore.selectedPlayers.length -
                selectCircleStore.selectedPlayersToRemove.length >
              courtBookingStore.totalPlayersToSelect
            }
          />
        </div>
      </div>
    </div>
  ) : null;
});
